import { useBranches, useDepartments } from '../../lib/queries';

import type { CSSProperties } from 'react';

interface DimensionFilterProps {
  companyId: string | undefined;
  branchId: string;
  departmentId: string;
  onBranchChange: (id: string) => void;
  onDepartmentChange: (id: string) => void;
  style?: CSSProperties;
}

/**
 * A branch + department filter pair for list-view filter rows. Unlike the
 * picker components, the placeholder option here means "all" (no filter),
 * matching the "ทั้งหมด" convention used across the list routes.
 */
export function DimensionFilter({
  companyId,
  branchId,
  departmentId,
  onBranchChange,
  onDepartmentChange,
  style,
}: DimensionFilterProps) {
  const { data: branches = [] } = useBranches(companyId, true);
  const { data: departments = [] } = useDepartments(companyId, true);
  return (
    <>
      <select
        className="select"
        value={branchId}
        onChange={(e) => onBranchChange(e.target.value)}
        style={style}
      >
        <option value="">สาขา: ทั้งหมด</option>
        {branches.map((b) => (
          <option key={b.id} value={b.id}>
            {b.code} — {b.nameTh}
          </option>
        ))}
      </select>
      <select
        className="select"
        value={departmentId}
        onChange={(e) => onDepartmentChange(e.target.value)}
        style={style}
      >
        <option value="">หน่วยงาน: ทั้งหมด</option>
        {departments.map((d) => (
          <option key={d.id} value={d.id}>
            {d.code} — {d.nameTh}
          </option>
        ))}
      </select>
    </>
  );
}
